import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Paper from '@material-ui/core/Paper';
import LoginForm from './LoginForm';
import * as actions from '../../actions';
import Footer from '../index/Footer';
import Header from '../index/Header';

const Layout = styled.div`
	min-height: calc(100vh - 60px);
	display: flex;
	flex-direction: column;
`;

const Page = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 48px 16px;
	background: radial-gradient(
			900px 420px at 50% 0%,
			rgba(198, 85, 214, 0.28),
			transparent 60%
		),
		radial-gradient(
			800px 380px at 15% 10%,
			rgba(255, 0, 128, 0.14),
			transparent 55%
		),
		linear-gradient(180deg, #24112e 0%, #f6f6f9 55%);
`;

const Card = styled(Paper)`
	max-width: 440px;
	margin: 0 auto;
	padding: 28px 24px;
	border-radius: 18px !important;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.14) !important;
`;

const CardInner = styled.div`
	text-align: center;
`;

const Logo = styled.img`
	max-height: 64px;
	margin-top: 6px;

	@media (max-width: 600px) {
		max-height: 56px;
	}
`;

const Title = styled.h1`
	margin: 16px 0 6px;
	font-size: 22px;
	font-weight: 700;
	color: #111;
`;

const Subtitle = styled.p`
	margin: 0 0 18px;
	font-size: 14px;
	color: rgba(17, 17, 17, 0.7);
`;

const ErrorText = styled.div`
	margin-top: 12px;
	font-size: 13px;
	color: #9f0004;
	text-align: center;
`;

const FinePrint = styled.p`
	margin: 14px 0 0;
	font-size: 12px;
	line-height: 1.5;
	color: rgba(17, 17, 17, 0.72);
	text-align: center;
`;

const FinePrintLink = styled.a`
	color: #c655d6;
	text-decoration: none;
	font-weight: 600;

	&:hover {
		text-decoration: underline;
	}
`;

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canSubmit: false
		};
		this.history = this.props.history;
	}
	componentDidMount() {
		document.title = 'Login | Chekkit Enterprise';
	}

	componentWillUnmount() {
		document.body.className = document.body.className.replace(
			'red-background',
			''
		);
	}

	renderError = () => {
		if (this.props.activated === false) {
			return `* Your account has been closed. Please contact support@chekkit.io if you would like to re-open your account.`;
		}

		if (this.props.error) {
			return `* ${this.props.error}`;
		}

		return '';
	};

	render() {
		const error = this.renderError();
		return (
			<div>
				<Header />
				<Layout>
					<Page>
						<Card zDepth={0}>
							<CardInner>
								<Logo src="/img/chekkit-logo.svg" alt="Chekkit" />
								<Title>Welcome back</Title>
								<Subtitle>
									Log in to your Chekkit Enterprise account
								</Subtitle>

								<LoginForm />

								{error ? <ErrorText>{error}</ErrorText> : null}

								<FinePrint>
									By logging in you agree to our{' '}
									<FinePrintLink
										href="https://www.chekkit.io/terms-of-use"
										target="_blank"
										rel="noopener noreferrer"
									>
										Terms of Use
									</FinePrintLink>{' '}
									and{' '}
									<FinePrintLink
										href="https://www.chekkit.io/privacy-policy"
										target="_blank"
										rel="noopener noreferrer"
									>
										Privacy Policy
									</FinePrintLink>
									.
								</FinePrint>
								<FinePrint>
									Forgot your password?{' '}
									<FinePrintLink href="/forgot-password">
										Reset it
									</FinePrintLink>
									.
								</FinePrint>
							</CardInner>
						</Card>
					</Page>
					<Footer />
				</Layout>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		error: state.error
	};
}

export default connect(mapStateToProps, actions)(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/register/Login.js